import { PageHeader } from "@dmca/frontend/components/nav";
import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router";
import { useDrawerLayoutContext } from "../../-DrawerLayoutContext";
import { useEffect } from "react";
import { checkPermissionsInLoader } from "@dmca/frontend/hooks";

export const Route = createFileRoute("/_authed/_drawerLayout/settings/user")({
  component: RouteComponent,
  loader: async ({ context }) => {
    await checkPermissionsInLoader("Admin::UpdateSelfProfile", context);
  },
  head: () => ({
    meta: [
      {
        title: "User Settings | DNA Dashboard",
      },
    ],
  }),
});

const listItems = [
  {
    label: "Profile",
    value: "profile",
  },
  {
    label: "Security",
    value: "security",
  },
];

function RouteComponent() {
  const navigate = Route.useNavigate();
  const id = useMatches({
    select: (matches) => {
      const match = matches[matches.length - 1];
      return match.id.split("/").pop() || "";
    },
  });

  const {
    selectedItem: [, setSelectedItem],
  } = useDrawerLayoutContext({
    showSearchBar: false,
    listItems,
    onItemSelected: (item) => {
      navigate({
        to: `/settings/user/${item.value}`,
      });
    },
  });

  useEffect(() => {
    if (id) {
      const selectedItem = listItems.find((item) => item.value === id);
      if (selectedItem) {
        setSelectedItem(selectedItem);
      }
    }
  }, [id, setSelectedItem]);

  return (
    <>
      <PageHeader>User Settings</PageHeader>
      <Outlet />
    </>
  );
}
